export enum TimeEvents {
  TeamOpenTab = 'time.team.OpenTab',
  ToDoCreated = 'time.todo.Created',
  ToDoScheduled = 'time.todo.Scheduled'
}
